angular.module("Main").filter("contains", function () {

    function filter(input, id, ids) {
        if (_.isNaN(id) || id === null || _.isUndefined(id)) {
            return "";
        } else {
            return _.includes(ids, _.toString(id));
        }
    }

    return filter;
});